import React, { lazy, Suspense } from 'react';
import { CenteredSpinner } from '@components/ui/feedback/CenteredSpinner';
import { FeatureGates, useFeatureGate } from '@services/statsig';

const LegacyPatientPage = lazy(() => import('../components/Patient/PatientDetailView'));
const NewPatientPage = lazy(() =>
  import('@features/patient-page').then(m => ({ default: m.PatientPage })),
);

export const PatientPageRoute: React.FC = () => {
  const isNewPatientPage = useFeatureGate(FeatureGates.SERVER_DRIVEN_PATIENT_PAGE);

  return (
    <Suspense fallback={<CenteredSpinner sx={{ height: '50vh' }} />}>
      {isNewPatientPage ? <NewPatientPage /> : <LegacyPatientPage />}
    </Suspense>
  );
};
